export function encryptID(id: any): string {
  const multiplier = 15485863;
  const offset = 736291847;
  return (parseInt(id) * multiplier + offset).toString();
}

/**
 * Normalisiert eine Fall-ID aus Route-Params o. ä. auf die Klartext-ID.
 *
 * Verschluesselte IDs (auch mehrfach verschluesselte aus vergifteten
 * localStorage-Eintraegen, siehe recentCasesStore) werden iterativ
 * entschluesselt; Klartext-IDs bleiben unveraendert. Verwechslung ist
 * ausgeschlossen, da echte IDs weit unterhalb des Offsets (736291847)
 * liegen und decryptID solche Werte nie als verschluesselt akzeptiert.
 */
export function normalizeCaseId(rawId: any): number | null {
  let current: any = rawId;
  for (let depth = 0; depth < 5; depth++) {
    const decrypted = decryptID(current);
    if (decrypted === null) break;
    current = decrypted;
  }

  const raw = String(current ?? "").trim();
  if (!/^\d+$/.test(raw)) return null;
  const parsed = parseInt(raw, 10);
  return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : null;
}

export function decryptID(encryptedId: any): number | null {
  const multiplier = 15485863n;
  const offset = 736291847n;

  try {
    const raw = String(encryptedId ?? "").trim();
    if (!/^\d+$/.test(raw)) return null;

    const value = BigInt(raw);
    if (value <= offset) return null;

    const diff = value - offset;
    if (diff % multiplier !== 0n) return null;

    const decoded = diff / multiplier;
    if (decoded <= 0n || decoded > BigInt(Number.MAX_SAFE_INTEGER)) return null;

    return Number(decoded);
  } catch {
    return null;
  }
}
